import { put } from 'typed-redux-saga';

import { ChannelHolder } from '../../../../../shared/helpers/channelHolder';
import { GRID_VIEW } from '../../../constants';
import { setUserPreferredGridViewAction } from '../../goloom-video-grid';
import { SignalingAPI } from '../api/SignalingAPI';

function isGridViewValid(view: string): view is GRID_VIEW {
    return Object.values(GRID_VIEW).includes(view as GRID_VIEW);
}

export function* setViewSaga({ signaling }: { signaling: SignalingAPI }) {
    const channelHolder = new ChannelHolder();

    try {
        while (true) {
            const view = yield* channelHolder.take(signaling.setGridViewEvent);

            if (!isGridViewValid(view)) {
                continue;
            }

            yield* put(setUserPreferredGridViewAction({ gridView: view }));
        }
    } finally {
        channelHolder.close();
    }
}
